import { line_reader } from './line_reader'

export default line_reader
export { line_reader }
export const lineReader = line_reader